export const CREATE_ENGIN = "CREATE_ENGIN";
export const RETRIEVE_ENGINS = "RETRIEVE_ENGINS";
export const UPDATE_ENGIN = "UPDATE_ENGIN";
export const DELETE_ENGIN = "DELETE_ENGIN";
export const DELETE_ALL_ENGINS = "DELETE_ALL_ENGINS";
